<template>
  <div id="head">
    <div style="width: 100%; display: flex; flex-direction: column;">
      <div style="display: flex; flex-wrap: wrap; justify-content: flex-start; align-items: center; gap: 10px;">
        <pre class="titlePre">
  <b>Xiangyu Li Lab</b>
<b class="myUniversity" >@Beijing Jiaotong University</b>
        </pre>

        <!-- 响应式菜单 -->
        <el-menu
          v-if="!isMobile"
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          router
          text-color="#FFFFFF"
          background-color="transparent"
          active-text-color="#ffffff"
          style="margin-top: 15px; margin-left: 10%;margin-right: 0px; height: 100px; margin-right: 10px; border-bottom: none; flex-grow: 1; justify-content: center; display: flex;gap: 10px;"
        >
          <el-menu-item index="Home" style="width: 90px;"> Home </el-menu-item>
          <el-menu-item index="People" style="width: 120px;">Members</el-menu-item>
          <el-menu-item index="Publications" style="width: 150px;">Publications</el-menu-item>
          <el-menu-item index="Research" style="width: 90px;">Tools</el-menu-item>
          <el-menu-item index="News" style="width: 90px;">News</el-menu-item>
          <el-menu-item index="Activities" style="width: 130px;">Activities</el-menu-item>
        </el-menu>


        <div v-if="isMobile" class="dropdown-container">
      <button @click="toggleMenu" class="dropdown-button">
        {{ currentMenuLabel }}
      </button>
      <ul v-if="menuVisible" class="dropdown-list">
        <li
          v-for="(item, index) in menuOptions"
          :key="index"
          @click="handleMobileSelect(item)"
        >
          {{ item.label }}
        </li>
      </ul>
    </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      isMobile: false, // 判断是否为移动端
      menuVisible: false, // 控制下拉菜单显示与否
      activeIndex: "Home", // 当前选中的菜单项
      currentMenuLabel: "Menu", // 移动端显示的菜单标题
      menuOptions: [
        { label: "Home", index: "Home" },
        { label: "Members", index: "People" },
        { label: "Publications", index: "Publications" },
        { label: "Tools", index: "Research" },
        { label: "News", index: "News" },
        { label: "Activities", index: "Activities" }
      ]
    }
  },
   methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible;

      if (this.menuVisible) {
        // 动态调整下拉菜单位置，确保不会超出屏幕
        this.$nextTick(() => {
          const button = this.$el.querySelector(".dropdown-button");
          const menu = this.$refs.dropdownMenu;
          const rect = button.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          const viewportWidth = window.innerWidth;

          let top = rect.bottom;
          let left = rect.left;

          // 判断下拉菜单是否超出屏幕底部
          if (top + menu.offsetHeight > viewportHeight) {
            top = viewportHeight - menu.offsetHeight - 10; // 留出一定空间
          }

          // 判断下拉菜单是否超出屏幕右侧
          if (left + menu.offsetWidth > viewportWidth) {
            left = viewportWidth - menu.offsetWidth - 10; // 留出一定空间
          }

          this.dropdownPosition = { top, left };
        });
      }
    },
    handleMobileSelect(item) {
      this.currentMenuLabel = item.label; // 更新按钮标题
      this.menuVisible = false; // 关闭下拉菜单
      this.$router.push({ name: item.index }).catch(() => {}); // 页面跳转
    }
  },
  mounted() {
    // 判断屏幕宽度以切换到移动端样式
    this.isMobile = window.innerWidth <= 768;
    window.addEventListener("resize", () => {
      this.isMobile = window.innerWidth <= 768;
    });
  }
}
</script>

<style scoped>

/* 下拉菜单样式 */
.dropdown-container {
  margin-left: 0px;
  position: relative;
  display: inline-block;
}

.dropdown-button {
  background-color: transparent;
  border: 1px solid #ffffff;
  color: #ffffff;
  padding: 10px 20px;
  cursor: pointer;
}

/* 下拉菜单样式 */
.dropdown-list {
  position: absolute;
  background-color: #ffffff;
  color: #000000;
  list-style: none;
  padding: 0;
  margin: 0;
  border: 1px solid #cccccc;
  width: 108px;
  max-height: 300px; /* 限制最大高度 */
  overflow-y: auto; /* 超出高度时出现滚动条 */
  z-index: 1000;
}

.dropdown-list li {
  padding-top: 5px;
  padding-bottom: 5px;
  cursor: pointer;
  white-space: nowrap; /* 防止文字换行 */
}

.dropdown-list li:hover {
  background-color: #f5f5f5;
}

#head {
  background: linear-gradient(to bottom, #020b80, #005BAC); /* 垂直渐变 */
  height: 85px;
  width: 100%;
}

/* .el-menu-demo .el-menu-item.is-active {
  border-bottom: none !important; 
} */

.el-menu--horizontal > .el-menu-item {
  border-bottom: none;
  text-decoration: none;
}

.titlePre{
  color: white; 
  font-size: 22px; 
  font-family: Arial; 
  text-align: center; 
  margin-top: 10px;
  margin-left: 100px;
}
.myUniversity{
  font-size: 16px;
}
.el-menu-item {
  font-size: 22px;
  font-family: Arial;
  padding: 0px;
  margin-top: 0px;
  transition: all 0.3s ease;
}

.el-menu-item:hover {
  background-color: transparent  !important; 
  color: #ffffff !important; /* 悬停时的文字颜色 */
  border-radius: 5px; /* 圆角效果 */
  box-shadow: -10px 0px 10px rgba(0, 0, 0, 0.3), 10px 0px 10px rgba(0, 0, 0, 0.3); /* 仅左右方向阴影 */
  transform: scale(1.0); /* 略微放大效果 */
}

.menu-span {
  font-size: 16px;
  margin-left: 50px;
}

.el-menu-demo {
  width: 60%;
  display: flex;
  justify-content: space-between; /* 在水平排列的菜单项之间增加间距 */
  margin: auto;
  color: white;
  border-bottom: none;
  text-decoration: none;
  flex-grow: 1;
  justify-content: center;
}

.el-menu-item {
  margin-left: 20px; /* 添加左边间距 */
  margin-right: 20px; /* 添加右边间距 */
}

.el-dropdown-menu {
  background-color: #333333;
  color: #ffffff;
}

.el-button {
  font-size: 16px;
}

.el-menu-demo {
  font-size: 18px;
}

@media (max-width: 768px) {
  .titlePre{
  color: white; 
  font-size: 14px; 
  font-family: Arial; 
  text-align: center; 
  margin-left: 10px;
  margin-top: 20px;
}
.myUniversity{
  font-size: 12px;
}
  .el-menu-item {
    font-size: 20px;
  }

  .el-menu-demo {
    width: 90%;
  }

  pre {
    font-size: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components2/Header.vue